// extracted by mini-css-extract-plugin
export default {"collapse":"CollapseCard_collapse__An93O"};